import { render, staticRenderFns } from "./externalRequest.vue?vue&type=template&id=e71fea74"
import script from "./externalRequest.vue?vue&type=script&lang=js"
export * from "./externalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports